import axios from 'axios';
import api from '../../../../../api/client';
import { AUCTION, PAYMENT } from '../../../../../api/endpoints';
import { handleApiResponse } from '../../../../../api/handlers';
import { getLoggedUser } from '../../../../../state/user';
import { apiUrl } from '../../../../../constants/global';
const user = getLoggedUser();
async function createPayment(payload) {
    return fetch(apiUrl + 'v2/edfapay/initiate', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + user.token,
        },
        body: JSON.stringify(payload),
      }).then((data) => data.json());
}


export async function fetchAcknowledgementPdf(auctionId, lang = 'en', enrollId = null) {
  try {
    const response = await api.get(AUCTION.ACKNOWLEDGEMENT_VIEW(auctionId), {
      params: { enrollId: enrollId, lang },
      responseType: 'blob',
    });
    return handleApiResponse(response);
  } catch (error) {
    const err = new Error(error.response?.data?.message || 'Failed to load acknowledgement PDF');
    err.response = error.response;
    err.status = error.response?.status || 500;
    throw err;
  }
}

export {
    createPayment
}